import styled from 'styled-components';
import { Colors } from '@fourthwall/components';
export const Strong = styled.strong `
  color: ${Colors.R300};
  font-weight: 600;
`;
